import Vue from 'vue'
import vuetify from './vuetify'
import { Flavors } from './constants'

export function flavorRes (path) {
  const flavor = Vue.prototype.$flavorName || 'rodobens'
  if (flavor === Flavors.ED) {
    path = path.replace('.png', '.svg')
  }
  return require(`../assets/flavors/${flavor}/${path}`)
}

/** @return VuetifyTheme */
export function colorRes (area_cliente) {
  const colors = flavorRes('values/colors').default
  if (area_cliente && colors.hasOwnProperty('area_cliente')) {
    return colors.area_cliente
  }
  return colors
}

export function loadFlavor (flavor, area_cliente = false) {
  for (const path of Object.keys(require.cache)) {
    if (path.includes('assets/flavors')) {
      delete require.cache[path]
    }
  }

  Vue.prototype.$flavorName = flavor

  document.getElementById('favicon').href = flavorRes('favicon.ico')

  Object.assign(vuetify.framework.theme.currentTheme, colorRes(area_cliente))
}
